export const WORD_SEARCH_THEME = {
  container: 'autocomplete',
  containerOpen: 'autocomplete-open',
  input: 'word',
  inputOpen: 'word-open',
  inputFocused: 'word-focused',
  suggestionsContainer: 'search-results-container',
  suggestionsContainerOpen: 'search-results-open',
  suggestionsList: 'search-results',
  suggestion: 'tagging-results db ellipsis',
  suggestionFirst: 'result-first',
  suggestionHighlighted: 'focused-tag',
  sectionContainer: 'result-section',
  sectionContainerFirst: 'result-section-first',
  sectionTitle: 'result-section-title',
}

export const LOCATION_SEARCH_THEME = {
  ...WORD_SEARCH_THEME,
  input: 'location',
}

export const LOCATION_TYPES = 'place,region,postcode'
export const COUNTRY_CODES = 'us'

export const FLATPICKR_DEFAULTS = {
  allowInput: true,
  defaultHour: 0,
  time_24hr: true,
  altInputClass: 'date-input',
  dateFormat: 'm/d/Y',
  monthSelectorType: 'static',
}
